import { render, staticRenderFns } from "./AmountsYTermsWC.vue?vue&type=template&id=32902c89&"
import script from "./AmountsYTermsWC.vue?vue&type=script&lang=js&"
export * from "./AmountsYTermsWC.vue?vue&type=script&lang=js&"
import style0 from "./AmountsYTermsWC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports